import type { ProductData } from '@/gql/reviews'
import { ReviewsProductRouteTabs, ReviewsRouteName } from '@/router/types'

import { hasItems, hasText, hasTranslationValue, isAnswered, type SectionConfig } from './completionTypes'

export const productCompletionSections: SectionConfig<ProductData>[] = [
  {
    id: ReviewsProductRouteTabs.Details,
    labelKey: 'Reviews.profileCompletion.section.details',
    editRouteName: ReviewsRouteName.ReviewsProductEditDetails,
    fields: [
      { key: 'logo', isComplete: (p) => !!p.logo },
      { key: 'shortDescription', isComplete: (p, l) => hasTranslationValue(p.shortDescriptionTranslations, l) },
      { key: 'description', isComplete: (p, l) => hasTranslationValue(p.descriptionTranslations, l) },
      { key: 'mainCategory', isComplete: (p) => !!p.mainCategory },
      { key: 'url', isComplete: (p, l) => hasTranslationValue(p.urlTranslations, l) },
      { key: 'hero', isComplete: (p) => !!p.hero },
      { key: 'categories', isComplete: (p) => hasItems(p.categories) },
      { key: 'linkedin', isComplete: (p) => p.configFlags.socialLinksAllowed && hasText(p.linkedin) },
      { key: 'twitter', isComplete: (p) => p.configFlags.socialLinksAllowed && hasText(p.twitter) },
      {
        key: 'secondaryCta',
        isComplete: (p, l) =>
          p.configFlags.ctaSecondaryEditable && (hasTranslationValue(p.ctaSecondaryUrlTranslations, l) || hasText(p.ctaSecondary?.url)),
      },
    ],
  },
  {
    id: ReviewsProductRouteTabs.GlobalFeatures,
    labelKey: 'Reviews.profileCompletion.section.globalFeatures',
    editRouteName: ReviewsRouteName.ReviewsProductEditGlobalFeatures,
    fields: [
      { key: 'cloud', isComplete: (p) => isAnswered(p.cloud) },
      { key: 'onPremise', isComplete: (p) => isAnswered(p.onPremise) },
      { key: 'anytimeSupport', isComplete: (p) => isAnswered(p.anytimeSupport) },
      { key: 'germanSupport', isComplete: (p) => isAnswered(p.germanSupport) },
      { key: 'germanLocation', isComplete: (p) => isAnswered(p.germanLocation) },
      { key: 'euLocation', isComplete: (p) => isAnswered(p.euLocation) },
      { key: 'euStandardContract', isComplete: (p) => isAnswered(p.euStandardContract) },
      { key: 'euCompanyAffiliated', isComplete: (p) => isAnswered(p.euCompanyAffiliated) },
    ],
  },
  {
    id: ReviewsProductRouteTabs.Pricing,
    labelKey: 'Reviews.profileCompletion.section.pricing',
    editRouteName: ReviewsRouteName.ReviewsProductEditPricing,
    fields: [
      {
        key: 'pricingInfo',
        isComplete: (p) =>
          hasItems(p.pricingPlans) ||
          p.noPricingPlans === true ||
          p.freePlanAvailable === true ||
          p.freeTrial === true ||
          p.freeDemo === true,
      },
      { key: 'disclaimer', isComplete: (p, l) => hasTranslationValue(p.disclaimerTextTranslations, l) },
    ],
  },
  {
    id: ReviewsProductRouteTabs.Assets,
    labelKey: 'Reviews.profileCompletion.section.assets',
    editRouteName: ReviewsRouteName.ReviewsProductEditAssets,
    fields: [
      { key: 'screenshots', isComplete: (p) => hasItems(p.screenshots) },
      { key: 'documents', isComplete: (p) => hasItems(p.documents) },
    ],
  },
]
